import type { FC, ReactNode } from 'react'

import { ArrowUp, Heart } from 'lucide-react'
import { FOOTER } from '@/constants/birthday'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='relative bg-night px-5 pb-14 pt-4 text-center text-white'>
            <div className='mx-auto max-w-3xl'>
                <div aria-hidden className='mx-auto flex items-center justify-center gap-3 text-rose-300/70'>
                    <span className='h-px w-24 bg-gradient-to-r from-transparent to-current' />
                    <Heart className='size-4 fill-current' />
                    <span className='h-px w-24 bg-gradient-to-l from-transparent to-current' />
                </div>

                <p className='mt-10 font-script text-5xl leading-tight text-rose-300 text-balance sm:text-6xl'>
                    {FOOTER.title}
                </p>

                <p className='mt-3 text-lg font-semibold text-white/80'>
                    {FOOTER.line}
                </p>

                <a
                    href='#hero'
                    className='mt-9 inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm font-bold text-white/85 transition hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50'
                >
                    <ArrowUp className='size-4' />
                    {FOOTER.backToTop}
                </a>
            </div>
        </footer>
    )
}

export default SiteFooter
